import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "image-variable-icon" }
const _hoisted_2 = ["src", "title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("span", _hoisted_1, [
    _createElementVNode("img", {
      src: _ctx.imgUrl,
      title: _ctx.name
    }, null, 8, _hoisted_2)
  ]))
}